import { render, staticRenderFns } from "./ActivityBasicInfo.vue?vue&type=template&id=2b09c326&scoped=true"
import script from "./ActivityBasicInfo.vue?vue&type=script&lang=js"
export * from "./ActivityBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./ActivityBasicInfo.vue?vue&type=style&index=0&id=2b09c326&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09c326",
  null
  
)

export default component.exports